<template>
  <section  class="elementor-section elementor-top-section elementor-element elementor-element-63798de elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="63798de" data-element_type="section" data-e-type="section" data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
    <div class="elementor-container elementor-column-gap-no">
      <div class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-73b70d3" data-id="73b70d3" data-element_type="column" data-e-type="column">
        <div class="elementor-widget-wrap elementor-element-populated">
          <div class="elementor-element elementor-element-6752950 elementor-position-inline-end elementor-widget__width-auto elementor-mobile-position-inline-end elementor-view-default elementor-invisible elementor-widget elementor-widget-icon-box" data-id="6752950" data-element_type="widget" data-e-type="widget" data-settings="{&quot;_animation&quot;:&quot;slideInUp&quot;,&quot;_animation_tablet&quot;:&quot;none&quot;}" data-widget_type="icon-box.default">
            <div class="elementor-widget-container">
              <div class="elementor-icon-box-wrapper">
                <div class="elementor-icon-box-icon">
                  <span  class="elementor-icon">
                    <i aria-hidden="true" class="vamtamtheme- vamtam-theme-line-titles"></i>
                  </span>
                </div>
                <div class="elementor-icon-box-content">
                  <h5 class="elementor-icon-box-title">
                    <span>{{ homeContentStore.contents.services.title }}</span>
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div class="elementor-element elementor-element-19b33cf elementor-invisible elementor-widget elementor-widget-heading" data-id="19b33cf" data-element_type="widget" data-e-type="widget" data-settings="{&quot;_animation&quot;:&quot;fadeIn&quot;,&quot;_animation_tablet&quot;:&quot;none&quot;,&quot;_animation_delay&quot;:500}" data-widget_type="heading.default">
            <div class="elementor-widget-container">
              <h2 class="elementor-heading-title elementor-size-default" v-html="homeContentStore.contents.services.descriptions"></h2>
            </div>
          </div>
        </div>
      </div>
      <div class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-1352f44" data-id="1352f44" data-element_type="column" data-e-type="column">
        <div class="elementor-widget-wrap elementor-element-populated">
          <div v-for="(services, index) in generalStore.categories" :key="services.id" class="list-service">
            <div class="elementor-element elementor-element-bae9fac elementor-widget__width-auto elementor-widget elementor-widget-heading" data-id="bae9fac" data-element_type="widget" data-e-type="widget" data-widget_type="heading.default">
              <div class="elementor-widget-container">
                <h6 class="elementor-heading-title elementor-size-default">0{{index + 1}}</h6>
              </div>
            </div>
            <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-722bbd9 elementor-widget__width-initial elementor-align-justify vamtam-btn-text-align vamtam-has-underline-anim elementor-widget elementor-widget-button" data-id="722bbd9" data-element_type="widget" data-e-type="widget" data-widget_type="button.default">
              <div class="elementor-widget-container">
                <div class="elementor-button-wrapper">
                  <a class="elementor-button elementor-button-link elementor-size-sm" :href="`/our-services/category/` + services.slug">
                    <span class="elementor-button-content-wrapper">
                      <span class="elementor-button-icon">
                        <i aria-hidden="true" class="vamtamtheme- vamtam-theme-arrow-right"></i>
                      </span>
                      <span class="elementor-button-text">{{ services.name }}</span>
                    </span>
                  </a>
                </div>
              </div>
            </div>
            <div class="elementor-element elementor-element-9e22c56 elementor-widget-divider--view-line elementor-widget elementor-widget-divider" data-id="9e22c56" data-element_type="widget" data-e-type="widget" data-widget_type="divider.default">
              <div class="elementor-widget-container">
                <div class="elementor-divider">
                  <span class="elementor-divider-separator"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { onMounted } from 'vue'
  import { useHomeContentStore } from '@/stores/homeContentStore'
  import { useGeneralStore } from '@/stores/generalStore'

  const baseUploadURL = process.env.VUE_APP_API_URL;

  export default {
    name: 'ServicesSectionComponent',
    setup() {
      const homeContentStore = useHomeContentStore()
      const generalStore = useGeneralStore()

      onMounted(async () => {
        await homeContentStore.fetchContentPage()
        await generalStore.fetchGeneral()
      })

      return {
        homeContentStore,
        generalStore,
      }
    },
    data() {
      return{
        baseUploadURL: baseUploadURL,
      }
    },
  }
</script>

<style scoped>
  .elementor-1905 .elementor-element.elementor-element-63798de {
    margin-bottom: 100px;
    padding: 100px 30px 140px 30px;
  }
  .elementor-1905 .elementor-element a.elementor-button {
    font-size: 18px !important;
  }

  /* .elementor-1905 .elementor-element.elementor-element-63798de .elementor-heading-title {
    font-size: 20px !important;
  } */
  /* .elementor-kit-5 {
    --e-global-typography-vamtam_h2-font-size: 30px;
  } */
  .elementor-kit-5 h2 {
    font-size: 40px;
  }

  .list-service {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    align-content: flex-start;
    width: 100vh;
    border-bottom: 1px solid #4e4e4e;
  }
</style>